import ModalLayout from '@/modules/drivers/modals/shared/ModalLayout'
import React from 'react'
import DayTypesContent from './DayTypesContent'
import DayTypesFooter from './DayTypesFooter'
import DayTypesHeader from './DayTypesHeader'
import { useSchedule } from '../../context/ScheduleContext'
import useTimesheetService from '@/modules/drivers/services/TimesheetService'

const DayTypesModal = ({
  close,
  companyId,
  driverId,
  onSubmit = null,
  applyScheduleHours = false,
}) => {
  const loading = false
  const {
    selectedDays,
    selectedDayType,
    setIsLoading,
    refresh,
    setSelectedDays,
  } = useSchedule()
  const { changeDayTypes } = useTimesheetService()

  const changeDayType = async () => {
    setIsLoading(true)
    try {
      await changeDayTypes({
        companyId: companyId,
        driverId: Number(driverId),
        dates: selectedDays,
        dayType: selectedDayType,
        notes: null,
        applyScheduleHours,
      })
    } catch (error) {
      console.error('Error changing day type:', error)
    } finally {
      onSubmit?.()
      setIsLoading(false)
      refresh()
      setSelectedDays([])
      close()
    }
  }

  return (
    <ModalLayout customZIndex={9999}>
      <div className="tw-flex tw-h-full tw-max-h-[460px] tw-w-[460px] tw-max-w-[800px] tw-flex-col tw-justify-between tw-rounded-lg tw-bg-white">
        <DayTypesHeader close={close} />
        <DayTypesContent companyId={companyId} />
        <DayTypesFooter loading={loading} submitData={() => changeDayType()} />
      </div>
    </ModalLayout>
  )
}

export default DayTypesModal
